import { configureStore } from "@reduxjs/toolkit";
import dropdownReducer from "../redux/reducers/dropdownReducer";
import profileReducer from "../redux/reducers/profileReducer";
import TitleListreducer from "../redux/reducers/TitleListreducer";
import SeasonReducer from "../redux/reducers/SeasonReducer";
import DivisionReducer from "./reducers/DivisionReducer";
import ImprintReducer from "../redux/reducers/ImprintReducer";
import FormatReducer from "../redux/reducers/formatReducer";
import managingEditorReducer from "../redux/reducers/managingEditorReducer";
import editorReducer from "../redux/reducers/editorReducer";
import BisanStatusReducer from "../redux/reducers/BisanStatusReducer";
import UserReducer from "../redux/reducers/UserReducer";
import isbnReducer from "./reducers/ISBNSReducer";
import AUTHOR1Reducer from "./reducers/AUTHOR1Reducer";
import eanReducer from "./reducers/EansReducer";
import detailPageReducer from './reducers/DetailPageReducer'
import titleSalesReducer from './reducers/titleListSalesReducer';
import titleSalesYTDReducer from './reducers/titleListYTDSalesReducer';
import titleSalesMTDReducer from './reducers/titleListMTDSalesReducer';
import titleSalesLTDReducer from './reducers/titleListLTDSalesReducer';
import titleSalesBookScanReducer from './reducers/titleListBookscanSalesReducer';
import titleListAmazonReducer from './reducers/titleListAmazonReducer';
import titleListReaderLinkReducer from "./reducers/titleListReaderLinkReducer";
import titleSalesInventoryReducer from './reducers/titleListInventorySalesReducer';
import boUnitsDetailsReducer from "./reducers/boUnitsDetailsReducer";
import TmmExportLinkReducer from "./reducers/TmmExportLinkReducer";
import LicensorReducer from "./reducers/LicensorReducer";
import SeriesReducer from "./reducers/SeriesReducer";
import InventoryStockReportReducer from "./reducers/InventoryStockReportReducer";

export const store = configureStore({
  reducer: {
    dropdownReducer,
    BisanStatusReducer,
    AUTHOR1Reducer,
    ImprintReducer,
    FormatReducer,
    profileReducer,
    UserReducer,
    eanReducer,
    managingEditorReducer,
    editorReducer,
    DivisionReducer,
    TitleListreducer,
    SeasonReducer,
    isbnReducer,
    detailPageReducer,
    titleSalesReducer,
    titleSalesYTDReducer,
    titleSalesMTDReducer,
    titleSalesLTDReducer,
    titleSalesBookScanReducer,
    titleSalesInventoryReducer,
    titleListAmazonReducer,
    titleListReaderLinkReducer,
    TmmExportLinkReducer,
    boUnitsDetailsReducer,
    LicensorReducer,
    SeriesReducer,
    InventoryStockReportReducer,
  },
});
export type AppStore = typeof store; // type of our store variable

// Infer the RootState and App type from the store itself
export type RootState = ReturnType<AppStore["getState"]>;

export type AppDispatch = AppStore["dispatch"];
